import { Form, Typography, message } from "antd";
import { useForm } from "antd/es/form/Form";
import OfferStep from "pages/campaign/OfferStep";
import { useLoaderData, useNavigate } from "react-router-dom";
import "./Campaign.scss";
import { CampaignEdit } from "interfaces/campaign-edit";
import { useCallback, useEffect, useMemo, useState } from "react";
import { LocationAvailability } from "interfaces/location-availability";
import {
  checkTierAvailability,
  updateCampaignCompensation,
} from "services/SauceService";
import { debounce } from "lodash";
import { useSelector } from "react-redux";
import { BusinessState } from "redux-context/business";
import {
  buildCampaignCompensationPayload,
  getCampaignVenuesFromDetails,
} from "helpers/campaignCompensationPayload";

const CampaignEditOffer: React.FC = () => {
  const campaign = useLoaderData() as CampaignEdit;
  const [loading, setLoading] = useState<boolean>(false);
  const campaignVenues = useMemo(() => {
    return getCampaignVenuesFromDetails(campaign);
  }, [campaign]);
  const [initialValues] = useState<any>({
    ...buildCampaignCompensationPayload(campaign, campaignVenues),
  });
  const [locationAvailability, setLocationAvailability] =
    useState<LocationAvailability>();
  const [form] = useForm();
  const navigate = useNavigate();
  const { business } = useSelector((state: BusinessState) => state.business);

  const handleSubmit = async () => {
    const values = form.getFieldsValue(true);
    setLoading(true);
    const response = await updateCampaignCompensation(values);
    if (response) {
      message.success("Campaign offer updated successfully");
      navigate("/campaigns");
    } else {
      message.error("Failed to update campaign offer");
    }
    setLoading(false);
  };

  const handleValueChange = useCallback(async () => {
    const {
      venues,
      minFollowersAmount,
      foodComp,
      socialMediaName,
      creatorCategories,
      gender,
      dietaryRestrictions,
      minRating,
      tiers,
    } = form.getFieldsValue(true);
    if (venues?.length > 0 && business._id) {
      setLoading(true);
      try {
        const response: any = await checkTierAvailability({
          businessId: business._id,
          venues,
          minFollowersAmount,
          foodComp,
          socialMediaName,
          categories: creatorCategories,
          gender,
          dietaryRestrictions,
          minRating,
          tiers,
        });
        setLocationAvailability(response);
      } catch (error: any) {
        console.error("Error checking location availability:", error);
        message.error(
          error?.response?.data?.message ||
            "Failed to check location availability"
        );
      } finally {
        setLoading(false);
      }
    }
  }, [form, business]);

  const handleValueChangeDebounced = useMemo(
    () => debounce(handleValueChange, 400),
    [handleValueChange]
  );

  useEffect(() => {
    handleValueChange();
  }, [handleValueChange]);

  return (
    <div className="campaign create">
      <Typography.Title level={3} style={{ fontSize: 32, margin: 0 }}>
        Edit Campaign Offer
      </Typography.Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={initialValues}
      >
        <OfferStep
          form={form}
          loading={loading}
          showSocialMediaName={false}
          locationAvailability={locationAvailability}
          handleValueChange={handleValueChange}
          handleValueChangeDebounced={handleValueChangeDebounced}
          onClickNext={() => form.submit()}
          onClickBack={() => navigate("/campaigns")}
          textNext="Update"
        />
      </Form>
    </div>
  );
};

export default CampaignEditOffer;
